<template>
  <div class="tab">
    <div>
      <span @click="returnFun()">＜返回</span>
      <h4>学生培训</h4>
      
      <img src="../../assets/growthThinking/list7/1.png" alt />
      <span>绘制大脑图</span>
      <img src="../../assets/growthThinking/list7/2.png" alt />
      <span>学生们在积极地投入活动</span>
      <img src="../../assets/growthThinking/list7/3.png" alt />
      <span>学生们活动后的合影</span>
      <img src="../../assets/growthThinking/list7/4.png" alt />
      <span>东城区心理教师培训大合影</span>
      <img src="../../assets/growthThinking/list7/5.png" alt />
      <span>向家长讲解如何和孩子玩大脑游戏</span>
      
    </div>
  </div>
</template>
<script>
export default {
  name: "list7",
  data() {
    return {};
  },
  props: ["listOrCon"],
   methods:{
    returnFun(){
      this.$emit("returnPage")
    }
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>
<style scoped>
.tab > div {
  padding: 0;
}
.tab > div > span:first-child{
  cursor: pointer;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 5px;
  color: #7ecef4;
  border: solid 1px #7ecef4
}
.tab > div > h4 {
  text-align: center;
  font-size: 24px;
}

.tab > div > img {
  margin: 20px 0;
}
.tab > div > span {
  display: block;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/growthThinking/list7.vue